<color-cfg *ngIf="showColorCfg" [colorKey]="data.colorKey"></color-cfg>
<button (click)="globals.isDebug = !globals.isDebug" *ngIf="mayDebug" class="debug" mat-icon-button micro-button>
  <mat-icon>bug_report</mat-icon>
</button>
<button (click)="clickClose()" *ngIf="data.showClose ?? true" mat-icon-button>
  <mat-icon>close</mat-icon>
</button>
